/* istanbul ignore file */
import { DropDownFilter, BaseFilterProps } from 'framework/list';
import { useInputHelper } from 'framework/form';
import EmployeeDropdown from '../input/EmployeeDropdown';

interface EmployeeSuggestionFilterProps extends BaseFilterProps {
  filter: any;
}

const EmployeeDropdownFilter = ({ filter, ...props }: EmployeeSuggestionFilterProps) => {
  const { getLabel, getOnChangeCallback } = useInputHelper(props);

  return (
    <DropDownFilter {...props}>
      <EmployeeDropdown
        filter={filter}
        label={getLabel() || ''}
        onChangeCallback={getOnChangeCallback()}
        showLoader
        {...props}
      />
    </DropDownFilter>
  );
};

export default EmployeeDropdownFilter;
